import PaymentTypeField from './PaymentTypeField';

export default PaymentTypeField;
